import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/admin/AdminRefundPolicy.css';

const AdminRefundPolicy = () => {
  const navigate = useNavigate();
  
  // 이전 페이지로 돌아가기 함수
  const handleBack = () => {
    navigate(-1); // 뒤로가기 구현
  };

  return (
    <div className="refundPolicyContainer">
      <h1 className="pageTitle">📄 TapGo 유료 플랜 환불 규정</h1>
      
      <div className="policyContent">
        <p className="policyIntro">본 환불 규정은 [TapGo] 유료 플랜(1개월, 6개월, 12개월)에 적용됩니다.</p>
        
        <section className="policySection">
          <h2 className="sectionNumber">1. 환불 정책</h2>
          <ul className="policyList">
            <li>유료 플랜 결제 후 7일 이내에 환불을 요청하는 경우, 아래 조건에 따라 환불이 가능합니다.</li>
            <li>환불 요청 시에는 반드시 환불 사유를 명확하게 기재해야 합니다.</li>
            <li>결제 후 일정 기간 서비스를 이용한 경우, 해당 기간을 기준으로 부분 환불이 적용됩니다.</li>
          </ul>
        </section>
        
        <section className="policySection">
          <h2 className="sectionNumber">2. 환불 금액</h2>
          <ul className="policyList">
            <li>서비스를 전혀 사용하지 않은 경우 전액 환불됩니다.</li>
            <li>일부 사용 시, 사용 개월 수를 기준으로 정가 요금 차감 후 환불됩니다.</li>
            <li>예시 (6개월 요금제, ₩60,000 기준): 2개월 사용 후 환불 요청 시 → ₩12,000 × 2개월 = ₩24,000 차감 → ₩36,000 환불</li>
            <li>사용 중이던 당월은 7일 이상 사용 시 해당 월 전체는 환불 대상에서 제외됩니다.</li>
          </ul>
        </section>
        
        <section className="policySection">
          <h2 className="sectionNumber">3. 환불 불가 사유</h2>
          <ul className="policyList">
            <li>다음과 같은 경우에는 환불이 불가능합니다:</li>
            <li>유료 결제 후 7일이 지난 경우</li>
            <li>해당 월을 7일 이상 사용한 경우, 해당 월 요금은 환불되지 않습니다</li>
            <li>사용자의 귀책 사유로 인해 서비스 이용이 제한되거나 계정이 정지된 경우</li>
            <li>프로모션, 이벤트, 할인 상품에 대해 '환불 불가'에 동의한 경우</li>
          </ul>
        </section>
        
        <section className="policySection">
          <h2 className="sectionNumber">4. 환불 처리 기간</h2>
          <ul className="policyList">
            <li>환불 요청 접수 후 영업일 기준 7일 이내에 환불 처리 결과를 안내해 드립니다.</li>
            <li>환불 금액은 결제에 사용된 동일한 결제 수단으로 환불됩니다.</li>
            <li>실제 환불 시점은 결제 수단 및 카드사 정책에 따라 차이가 있을 수 있습니다.</li>
          </ul>
        </section>

        <section className="policySection">
          <h2 className="sectionNumber">5. 무료 체험 정책</h2>
          <ul className="policyList">
            <li>TapGo는 향후 신규 사용자 대상 무료 체험 기능을 도입할 수 있습니다.</li>
            <li>무료 체험 정책이 시행될 경우, 제공 기간, 조건, 자동 결제 여부 등은 별도의 고지를 통해 안내드릴 예정입니다.</li>
          </ul>
        </section>

        <section className="policySection">
          <h2 className="sectionNumber">6. 면책 조항</h2>
          <ul className="policyList">
            <li>당사는 천재지변, 시스템 장애, 기타 불가항력적인 사유로 인해 서비스 제공이 일시적으로 불가능할 경우, 해당 기간에 대해 별도의 환불 책임을 지지 않습니다.</li>
          </ul>
        </section>

        <section className="policySection">
          <h2 className="sectionNumber">7. 규정 변경</h2>
          <ul className="policyList">
            <li>본 환불 규정은 사전 고지 없이 변경될 수 있으며, 변경 사항은 TapGo 앱 내 공지 또는 웹사이트를 통해 안내됩니다.</li>
            <li>변경된 환불 규정은 공지일 이후 신규 결제 건부터 적용됩니다.</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default AdminRefundPolicy; 